export default __webpack_public_path__ + "static/media/dcps_wide.600369fc.webp";